import React from 'react';

/**
 * Regular dot for normal data points
 * Renders a circle with the given color
 */
const RegularDot = (props) => {
  const { cx, cy, stroke, fill, className } = props;
  return (
    <g className={className}>
      <circle 
        cx={cx} 
        cy={cy} 
        r={8} 
        stroke={stroke}
        strokeWidth={2}
        fill={fill}
      />
    </g>
  );
};

export default RegularDot; 